import React from 'react';
var useCallback = React.useCallback, useRef = React.useRef;
/**
 * @returns a new validityChange function which emits validity only if the new validity
 * is different from the previous emitted validity.
 */
export function useEmitValidityIfChanged(validityChange) {
    var lastEmittedValidityRef = useRef();
    var emitValidity = useCallback(function (newValid) {
        if (lastEmittedValidityRef.current === undefined ||
            lastEmittedValidityRef.current !== newValid) {
            // emit validity only if newValid is different from last emitted value.
            validityChange(newValid);
            lastEmittedValidityRef.current = newValid;
        }
    }, [lastEmittedValidityRef, validityChange]);
    return emitValidity;
}
